import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const STUDENT = 'student'
const GRADE_LEVEL = 'grade_level'
const CONTENT_AREAS = 'content_areas'
const OTHER_CONTENT_AREA = 'other_content_area'
const ADJUSTMENT_TYPE = 'adjustment_type'
const ACCOMMODATIONS = 'accommodations'
const MODIFICATIONS = 'modifications'
const START_DATE = 'start_date'
const END_DATE = 'end_date'
const NOTES = 'notes'

/**
 * Form model
 */
const formModel = () => {
  return {
    [STUDENT]: {
      label: `${t('common.student')}`,
      name: STUDENT,
    },
    [GRADE_LEVEL]: {
      label: `${t('common.grade-level')}`,
      name: GRADE_LEVEL,
    },
    [CONTENT_AREAS]: {
      label: `${t('common.content-area')}`,
      name: CONTENT_AREAS,
    },
    [OTHER_CONTENT_AREA]: {
      label: `${t('content-areas.other')}`,
      name: OTHER_CONTENT_AREA,
    },
    [ADJUSTMENT_TYPE]: {
      label: `${t('common.type')}`,
      name: ADJUSTMENT_TYPE,
    },
    [ACCOMMODATIONS]: {
      label: `${t('common.accommodations')}`,
      name: ACCOMMODATIONS,
    },
    [MODIFICATIONS]: {
      label: `${t('common.modifications')}`,
      name: MODIFICATIONS,
    },
    [START_DATE]: {
      label: `${t('common.start-date')}`,
      name: START_DATE,
    },
    [END_DATE]: {
      label: `${t('common.end-date')}`,
      name: END_DATE,
    },
    [NOTES]: {
      label: `${t('common.notes')}`,
      name: NOTES,
    },   
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [STUDENT]: null,
  [GRADE_LEVEL]: null,
  [CONTENT_AREAS]: [],
  [OTHER_CONTENT_AREA]: '',
  [ADJUSTMENT_TYPE]: null,
  [ACCOMMODATIONS]: [{
    category: null,
    items: []
  },],
  [MODIFICATIONS]: [{
    category: null,
    items: []
  },],
  [START_DATE]: '',
  [END_DATE]: '',
  [NOTES]: '',
}

export default formModel
